import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = () => {
  const activities = [
    {
      id: 1,
      type: 'mention',
      title: 'New media mention detected',
      description: 'TechCrunch mentioned "The Digital Revolution" in their latest article',
      timestamp: '2 hours ago',
      icon: 'MessageSquare',
      iconColor: 'bg-primary',
      actionLabel: 'View Article',
      actionPath: '/analytics-dashboard'
    },
    {
      id: 2,
      type: 'email',
      title: 'Email campaign response',
      description: 'Sarah Johnson from BookReview Weekly replied to your pitch',
      timestamp: '4 hours ago',
      icon: 'Mail',
      iconColor: 'bg-success',
      actionLabel: 'View Response',
      actionPath: '/email-campaign-manager'
    },
    {
      id: 3,
      type: 'content',
      title: 'Press release published',
      description: 'AI-generated press release for "Mystery of the Lost Pages" is now live',
      timestamp: '6 hours ago',
      icon: 'FileText',
      iconColor: 'bg-accent',
      actionLabel: 'View Release',
      actionPath: '/press-kit-builder'
    },
    {
      id: 4,
      type: 'contact',
      title: 'New media contact added',
      description: 'Added 5 new contacts from Literary Review Magazine',
      timestamp: '1 day ago',
      icon: 'UserPlus',
      iconColor: 'bg-secondary',
      actionLabel: 'View Contacts',
      actionPath: '/media-contacts'
    },
    {
      id: 5,
      type: 'kit',
      title: 'Press kit updated',
      description: 'Updated author bio and added new book cover for Emma Thompson',
      timestamp: '2 days ago',
      icon: 'Edit',
      iconColor: 'bg-warning',
      actionLabel: 'View Kit',
      actionPath: '/press-kit-builder'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Recent Activity</h2>
        <button className="text-sm text-primary hover:text-primary/80 font-medium">
          View All
        </button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start space-x-4 p-3 rounded-lg hover:bg-muted/50 transition-colors duration-200">
            <div className={`p-2 rounded-lg ${activity?.iconColor} flex-shrink-0`}>
              <Icon name={activity?.icon} size={16} color="white" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground mb-1">{activity?.title}</h3>
              <p className="text-sm text-muted-foreground mb-2">{activity?.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground">{activity?.timestamp}</span>
                <button className="text-xs text-primary hover:text-primary/80 font-medium">
                  {activity?.actionLabel}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;